/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

export enum DigitalAssistantFeedbackTypes {
  currentTopic = 'On this topic',
  newTopic = 'New clinical topic',
  newDesign = 'New design feature',
  technicalIssue = 'Technical issue',
  patientSummary = 'Patient summary',
}

export const feedbackChoices = [
  { label: 'On this topic', value: DigitalAssistantFeedbackTypes.currentTopic },
  { label: 'New clinical topic', value: DigitalAssistantFeedbackTypes.newTopic },
  { label: 'New design feature', value: DigitalAssistantFeedbackTypes.newDesign },
  { label: 'Technical issue', value: DigitalAssistantFeedbackTypes.technicalIssue },
] as const;
